import { ConfiguratorsDataService } from '@icc/configurator/shared';
import { ActiveConfiguration } from '@icc/configurator/shared';
import { Shape, ConfigurationType, PriceSegment, PricePart, DiscountGroups } from '@icc/shared/types';
import { ComplexConfiguratorField, ComplexConfiguratorFieldConfig } from '@icc/shared/types/complex/ComplexConfiguratorField';
import { SketchData } from '@icc/shared/types/complex/SketchData';
import { ComplexConfiguration } from './ComplexConfiguration';

export class ComplexActiveConfiguration implements ActiveConfiguration {
    type: 'complex' = 'complex';

    valid: any = {};
    attributes = [];
    drawData;
    Name = '';
    Price = 0;
    PriceNoMargin = 0;
    PriceAfterMultiplier = 0;
    PriceAfterMultiplierNoMargin = 0;
    PriceAfterDiscounts = 0;
    PriceIsGross = false;
    PriceTaxRate = 0;
    Quantity = 1;
    Issues = [];
    Valid = {};
    PriceElems: any = {};
    PriceSegments: PriceSegment[] = [];
    PriceSegmentsNoMargin: PriceSegment[] = [];
    PriceParts: PricePart[] = [];
    PricePartsNoMargin: PricePart[] = [];
    timeLimit: number | null = null;
    timeLimitsStack = [];
    PriceValid = false;
    DiscountGroups: DiscountGroups = {};
    DiscountGroupsNoMargin: DiscountGroups = {};
    Discount = 0;
    Title = '';
    Description = '';
    Attachments = [];
    DrawId = '';

    configuratorId: number | null = 0;
    extId: string | null = null;
    index: string | null = null;
    fields: Record<string, ComplexConfiguratorField> = {};
    fieldsConfig: Record<string, ComplexConfiguratorFieldConfig> = {};
    rulesMode: 'simple' | 'blockly' = 'simple';
    departments: Record<number,string> | null = {};
    sketchMainData: SketchData | null = null;
    sketchAdditionalData: string[] = [];
    productId: number = null;
    productExtId: string = null;
    productName: string = null;
    configuratorName: string = null;
    selectedProducts: Record<string, {
        id: number;
        priceBeforePromotion: number;
        price: number;
        isGross: boolean;
        taxRate: number;
        currency: string;
        unitName: string;
        unitSymbol: string;
        unitId: number;
        unitCode: string;
    }> = {};

    // eslint-disable-next-line max-statements
    constructor(configuration?, private configuratorsDataService?: ConfiguratorsDataService, langCode = 'pl'/* , fieldsConfig?: any */) {
        if (configuration) {
            if (ComplexActiveConfiguration.is(configuration)) {
                for (const propName in configuration) {
                    if (typeof this[propName] !== 'undefined') {
                        this[propName] = configuration[propName];
                    }
                }
            } else {
                if (ComplexConfiguration.is(configuration)) {
                    this.Name = configuration?.name || configuration?.configuratorName || '';
                    this.Price = configuration.price;
                    this.PriceNoMargin = configuration.priceNoMargin;
                    this.PriceAfterMultiplier = configuration.priceAfterMultiplier;
                    this.PriceAfterMultiplierNoMargin = configuration.priceAfterMultiplierNoMargin;
                    this.PriceAfterDiscounts = configuration.priceAfterDiscounts;
                    this.PriceIsGross = configuration.priceIsGross;
                    this.PriceTaxRate = configuration.priceTaxRate;
                    this.Quantity = configuration.quantity;
                    this.PriceSegments = configuration.priceSegments;
                    this.PriceSegmentsNoMargin = configuration.priceSegmentsNoMargin;
                    this.PriceParts = configuration.priceParts;
                    this.PricePartsNoMargin = configuration.pricePartsNoMargin;
                    this.DiscountGroups = configuration.discountGroups;
                    this.DiscountGroupsNoMargin = configuration.discountGroupsNoMargin;
                    this.Title = configuration.title;
                    this.Description = configuration.description;
                    this.valid = configuration.valid;
                    this.attributes = configuration.attributes;
                    this.timeLimit = configuration.timeLimit;
                    this.Valid = configuration.valid;
                    this.timeLimitsStack = configuration.timeLimitsStack;
                    this.fields = configuration.fields;
                    this.fieldsConfig = configuratorsDataService.data.fieldsConfig;
                    this.configuratorId = configuration.configuratorId;
                    this.extId = configuration.extId;
                    this.index = configuration.index ?? null;
                    this.departments = configuration.departments;
                    this.productId = configuration.productId;
                    this.productExtId = configuration.productExtId;
                    this.productName = configuration.productName;
                    this.configuratorName = configuration.configuratorName;
                }
            }
        }

        this.configuratorsDataService = null;
    }

    public static is(configuration): configuration is ComplexActiveConfiguration {
        return configuration instanceof ComplexActiveConfiguration || !configuration.$version && configuration.type === 'complex';
    }
}
